import React from 'react';

import ContentHeading from '../../../shared/commonComponents/ContentHeading';
import EventItem from '../../../shared/commonComponents/EventItem';


const Overview = (props) => {

    return <div className='scroll-content'>
        <div className="px-3 py-4">
            <ContentHeading title="Overview" />
            <div className="content-padding overview">
                <div dangerouslySetInnerHTML={{ __html: props.stageDetails.longDescription }} />
            </div>
            <ContentHeading title="Activities in this Stage" />
        </div>
        <div className="content-padding">
            {props.activities && props.activities.length > 0 && props.activities.map(item => {
                return <EventItem item={item} key={"event-item" + item.activityId} showCompletion={false} />;
            })}
        </div>
    </div>;
};

export default Overview;